import {
  CollectionHold,
  Customer,
  Dormant,
  Duplicate,
  Inactive,
  Pending,
} from '@assets';
import { ArchiveArrowDownIcon } from '@atgfr8/icons/ArchiveArrowDown';
import type * as customerTypes from '@store/customers/types';
import { Match, Switch } from 'solid-js';

export const ActiveInActiveCustomer = (data: customerTypes.Customer) => {
  type statusTypes = customerTypes.statusTypes;
  const statusIcons: Record<keyof statusTypes, string> = {
    Customer: Customer,
    Deactivated: Inactive,
    Duplicate: Duplicate,
    'Collection Hold': CollectionHold,
    Dormant: Dormant,
    Pending: Pending,
    Inactive: Inactive,
    'Credit Hold': CollectionHold,
    'In Review': Pending,
    'In Collections': CollectionHold,
    Bankruptcy: Inactive,
    'Credit Review': Inactive,
    'Legal Review': Inactive,
    RFP: Inactive,
    Archived: '',
  };

  return (
    <>
      <Switch
        fallback={
          <img
            src={statusIcons[data.status as unknown as keyof statusTypes]}
            alt="status icon"
            class="w-6 h-6"
          />
        }
      >
        {/* @ts-expect-error - TS is just being annoying and won't cast to status types */}
        <Match when={data.status === 'Archived'}>
          <ArchiveArrowDownIcon fill="#1B4960" />
        </Match>
      </Switch>
      {data.status}
    </>
  );
};
